/**
 *
 * Handles all XT Favorite Schedule API calls
 * @author Kyle Ellman
 *
 */
import { getV2Resource, vkApiInstance } from "apis/vk";
import { waitForJobToFinish } from "apis/vk/jobs";

const getBaseUrl = systemId => `/v2/panels/${systemId}/favorite_schedules`;
const scheduleUrl = (systemId, number) => `${getBaseUrl(systemId)}/${number}`;

/**
 * Fetches XT Favorite Schedules
 * @param  {integer} systemId
 * @param  {boolean} refresh (optional)
 * @return {promise}
 */
export const get = ({ systemId, refresh }) =>
  getV2Resource({
    baseUrl: getBaseUrl(systemId),
    refresh
  });

/**
 * Creates XT Favorite Schedule
 * @param  {integer} systemId
 * @param  {object} schedule attributes to update
 * @return {promise}
 */
export const create = ({ systemId, schedule }) =>
  waitForJobToFinish(
    vkApiInstance.post(getBaseUrl(systemId), { favorite_schedule: schedule })
  );

/**
 * Updates XT Favorite Schedule
 * @param  {integer} systemId
 * @param  {integer} number schedule/favorite number
 * @param  {object} schedule attributes to update
 * @return {promise}
 */
export const update = ({ systemId, number, schedule }) =>
  waitForJobToFinish(
    vkApiInstance.patch(scheduleUrl(systemId, number), {
      favorite_schedule: schedule
    })
  );

/**
 * Deletes XT Favorite Schedule
 * @param  {integer} systemId
 * @param  {integer} number schedule/favorite number
 * @return {promise}
 */
export const destroy = ({ systemId, number }) =>
  waitForJobToFinish(vkApiInstance.delete(scheduleUrl(systemId, number)));
